import { Component, OnInit } from '@angular/core';
import { UserService } from '../../shared/user.service';
import { ErrorHandler } from '../../shared/ErrorHandler';

@Component({
  selector: 'app-clients-count-for-projects',
  templateUrl: './clients-count-for-projects.component.html',
  styleUrls: ['./clients-count-for-projects.component.css']
})
export class ClientsCountForProjectsComponent implements OnInit {

  constructor(private userService: UserService,private errorHandler: ErrorHandler) { }

  ngOnInit() {
    this.ClientsCountforProjects();
  }

  ClientsCountforProjects = function(){
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.clientsCountforProjects()
    .subscribe((data:any)=>{
      this.Client = data;
      document.getElementById('loader-spinner').style.display = "none";
    },(error)=>{
      document.getElementById('loader-spinner').style.display = "none";
      this.errorHandler.HandlerError(error);
    });

}

}



// WEBPACK FOOTER //
// ./src/app/reports/clients-count-for-projects/clients-count-for-projects.component.ts